import { useContext, useEffect, useRef, useState } from 'react';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import MenuSaleDateEdit from './MenuSaleDateEdit';
import MenuSalePeriod from './MenuSalePeriod';
import { Button, Space, Switch } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import { SocketContext } from '../../../App';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import dayjs from 'dayjs';

export default function MenuSaleDate(props: any) {

    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;
    const notificationApi = useNotificationInstance();
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    //周期数据
    const [menuSalePeriodData, setMenuSalePeriodData] = useState<any>();

    //周期窗口
    const [menuSalePeriodVisible, setMenuSalePeriodVisible] = useState(false);

    /** api服务id */
    const apiId = 'menuSaleDate';

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }

        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                initData();
            }
        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    const initData = async () => {
        const targetId = data.targetId;
        const targetKey = data.targetKey;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                targetId,
                targetKey
            }
        }
        ref.current.initData(currentData);

        setContextData({ ...contextData, refresh: false })
    }

    const handleDelete = (record: any) => {
        fetchApi.DELETE(wmService, {
            apiId,
            apiExtend: "remove",
            apiVariable: record.id,
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId,
                targetId: data.targetId,
                targetKey: data.targetKey
            }
        }).then(async res => {
            if (res.success) {
                showCustomNotification(notificationApi!, {
                    type: 'success',
                    message: "删除成功",
                    description: "success"
                });;
                await initData();
                if (res.data.state) {
                    closeModal(true);
                }
            }
        })
    };

    //打开周期窗口
    const handleMenuSalePeriod = (record: any) => {
        // console.log(record)
        sendData.id = record.id;
        sendData.title = record.startTime + " 至 " + record.endTime + " 的" + record.dateTypeName;
        sendData.targetId = data.targetId;
        sendData.targetKey = data.targetKey;
        sendData.dateType = record.dateType;
        sendData.price = data.price;
        setMenuSalePeriodData(sendData);
        setMenuSalePeriodVisible(true);
    };

    //关闭周期窗口
    const onCloseMenuSalePeriod = async (status: boolean) => {
        setMenuSalePeriodVisible(false);
        if (status) {
            await initData();
        }
    }

    //表头
    const columnsHead = [
        {
            title: '目标ID',
            dataIndex: 'targetId',
        },
        {
            title: '渠道',
            dataIndex: 'targetKey',
        },
        {
            title: '时间类型',
            dataIndex: 'dateTypeName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.dateTypeName}</div>
                )
            }
        },
        {
            title: '周期',
            dataIndex: '',
            key: 'menuSalePeriod',
            render: (text: any, record: any) => {
                if (record.menuSalePeriods.length > 0) {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" onClick={() => handleMenuSalePeriod(record)}>周期</Button>
                        </Space>
                    )
                }
                else {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" danger onClick={() => handleMenuSalePeriod(record)}>周期</Button>
                        </Space>
                    )
                }
            }
        },
        {
            title: '开始时间',
            dataIndex: 'startTime',
            render: (text: any, record: any) => {
                return (
                    <div>{dayjs(record.startTime).format("YYYY-MM-DD")}</div>
                )
            }
        },
        {
            title: '结束时间',
            dataIndex: 'endTime',
            render: (text: any, record: any) => {
                return (
                    <div>{dayjs(record.endTime).format("YYYY-MM-DD")}</div>
                )
            }
        },
        {
            title: '跳过节假日',
            dataIndex: 'isSkipHoliday',
            render: (text: any, record: any) => {
                if (record.dateType === 'discount') {
                    return (
                        <Switch checkedChildren="是" unCheckedChildren="否"
                            checked={text} key={record.id}
                        />
                    )
                }
            }
        }
    ];

    //传关参数
    let sendData = {
        type: 'EDIT',
        id: '',
        title: '',
        targetId: '',
        targetKey: '',
        dateType: '',
        price: 0
    }

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '销售 / 折扣时间',
        apiId,
        columns,
        showStates: true,
        showQuery: false,
        pagination: true,
        // showDelete: false,
        showAdd: true,
        showLogger: {
            logger: {
                id: 'salePeriodOpLogger'
            },
            loggerDisplay: true,
            loggerSingleDisplay: true,
            loggerQueryType: 'salePeriod',
            loggerQueryTypeExtendId: contextData?.currentBranchStoreId
        },
        EditComponent: MenuSaleDateEdit,
        sendPageData: {
            branchStoreId: contextData?.currentBranchStoreId,
            targetId: data.targetId,
            targetKey: data.targetKey
        },
        coverHandleDelete: handleDelete
    };

    return (
        <>
            <AntDraggableModal
                title={"【 " + data.title + " 】销售 / 折扣时间"}
                open={true}
                okText='关闭'
                // cancelText={stringHandle.isUndefined()}            
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={() => closeModal(true)}
                closable={false}
                maskClosable={false}
                width={1200}>

                <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>

                {menuSalePeriodVisible
                    ? (<MenuSalePeriod
                        closeModal={onCloseMenuSalePeriod} data={menuSalePeriodData} />)
                    : null}

            </AntDraggableModal>
        </>
    )
}